import http from 'plugins/axios';

export default {
    getMiningAliveList(data) {
        return http.get({
            url: '/admin/pledge/config/list',
            data: data
        });
    },

    createMiningAlive(data) {
        return http.post({
            url: '/admin/pledge/config/save',
            data: data,
            dataType: 'form'
        });
    },
    updateMiningAlive(data) {
        return http.post({
            url: '/admin/pledge/config/update',
            data: data,
            dataType: 'form'
        });
    },

    updateMiningAliveStatus(data) {
        return http.post({
            url: '/admin/pledge/config/updateStatus',
            data: data,
            dataType: 'form'
        });
    },


    getAllSupportCoin() {
        return http.get({
            url: '/admin/coin/allDisplay'
        });
    },
};
